import React, { createContext, useContext, useMemo } from 'react';
import { useUser, useAuth } from '@clerk/clerk-react';

const AuthContext = createContext();

const ROLE_HIERARCHY = { admin: 3, moderator: 2, viewer: 1 };

export function AuthProvider({ children }) {
  const { isLoaded, isSignedIn, user } = useUser();
  const { getToken } = useAuth();

  const value = useMemo(() => {
    const role = user?.publicMetadata?.role || 'viewer';
    const minecraftUuid = user?.publicMetadata?.minecraftUuid || null;
    const minecraftUsername = user?.publicMetadata?.minecraftUsername || null;

    const hasRole = (minimumRole) =>
      (ROLE_HIERARCHY[role] || 0) >= (ROLE_HIERARCHY[minimumRole] || 0);

    return {
      isLoaded,
      isSignedIn: isSignedIn || false,
      user,
      role,
      minecraftUuid,
      minecraftUsername,
      hasRole,
      isAdmin: role === 'admin',
      isModerator: hasRole('moderator'),
      getToken,
    };
  }, [isLoaded, isSignedIn, user, getToken]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAppAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAppAuth must be used within an AuthProvider');
  }
  return context;
}
